import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.739 13.73h-1.7V7.5h1.7v6.23zm0 2.77h-1.7v-1.636h1.7V16.5z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10 8.5a8.5 8.5 0 110-17 8.5 8.5 0 010 17z" })));
export default createSvgIcon(iconPath, "AlertOutline");
//# sourceMappingURL=AlertOutlineIcon.js.map